/*
 * Copyright by Intland Software
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Intland Software. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with Intland.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultConfig } from "./iframe-widget-config";
var context = window['contextPath'];
var getToken = function () {
    return fetch("".concat(context, "/externalwidget/authenticate.spr"))
        .then(function (response) { return response.json(); })
        .then(function (json) { return json.token; });
};
var IFrameWidgetHandlers = /** @class */ (function () {
    function IFrameWidgetHandlers(config, iFrame, selectedItem, selectedStream, selectedStreamBaselineId, selectedStreamBaselineName, preferredLanguage) {
        this.iFrame = iFrame;
        this.selectedItem = selectedItem;
        this.selectedStream = selectedStream;
        this.selectedStreamBaselineId = selectedStreamBaselineId;
        this.selectedStreamBaselineName = selectedStreamBaselineName;
        this.preferredLanguage = preferredLanguage;
        this.config = __assign(__assign({}, defaultConfig), (config || {}));
    }
    IFrameWidgetHandlers.prototype.authenticate = function () {
        return getToken().then(function (token) { return ({ token: token }); });
    };
    IFrameWidgetHandlers.prototype.resize = function (request) {
        this.iFrame.height = request.payload.height.toString();
        return Promise.resolve();
    };
    IFrameWidgetHandlers.prototype.getSelectedItem = function () {
        return Promise.resolve({ itemId: this.selectedItem });
    };
    IFrameWidgetHandlers.prototype.getSelectedStream = function () {
        return Promise.resolve({ streamId: this.selectedStream });
    };
    IFrameWidgetHandlers.prototype.reloadItem = function (request) {
        return this.config.reloadItemCallback(request.widgetId, request.payload.itemId) || Promise.resolve();
    };
    IFrameWidgetHandlers.prototype.getConfig = function () {
        return Promise.resolve({ config: this.config.remoteConfig });
    };
    IFrameWidgetHandlers.prototype.getBaseURL = function () {
        var baseUrl = new URL(context + '/api', window.location.origin);
        return Promise.resolve({ baseURL: baseUrl.toString() });
    };
    IFrameWidgetHandlers.prototype.getPreferredLanguage = function () {
        return Promise.resolve({ languageTag: this.preferredLanguage });
    };
    IFrameWidgetHandlers.prototype.getSelectedStreamBaseline = function () {
        return Promise.resolve({ streamBaselineId: this.selectedStreamBaselineId,
            streamBaselineName: this.selectedStreamBaselineName });
    };
    return IFrameWidgetHandlers;
}());
export { IFrameWidgetHandlers };
